import { Component, inject, OnInit, signal } from '@angular/core';
import { form, required, FormField, disabled } from '@angular/forms/signals';
import { BusinessAccountService } from '../../../../services/business-account/business-account.service';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { take } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { HasBoltOnDirectiveDirective } from '../../../../common/directives/has-bolt-on/has-bolt-on-directive.directive';
import { environment } from '../../../../../environments/environment';
import { NotHasBoltOnDirectiveDirective } from '../../../../common/directives/not-has-bolt-on/not-has-bolt-on-directive.directive';

@Component({
  selector: 'mb-affiliate-marketing',
  standalone: true,
  imports: [FormField, DatePipe, HasBoltOnDirectiveDirective, NotHasBoltOnDirectiveDirective],
  templateUrl: './affiliate-marketing.component.html',
  styleUrl: './affiliate-marketing.component.css'
})
export class AffiliateMarketingComponent implements OnInit {

  environment = environment;

  rakutenAdvertiserIdModel = signal({
    rakutenAdvertiserId: '',
  });
  rakutenAdvertiserIdForm = form(this.rakutenAdvertiserIdModel, (schemaPath: any) => {
    required(schemaPath.rakutenAdvertiserId, { message: 'Rakuten Advertiser ID is required' });
  });

  updatingAffiliateChanges = signal<boolean>(false);

  foundAdvertiserModel = signal({
    name: '',
    url: '',
  })
  foundAdvertiserForm = form(this.foundAdvertiserModel, (schemaPath: any) => {
    required(schemaPath.name, { message: 'Advertiser name is required' });
    required(schemaPath.url, { message: 'Advertiser URL is required' });
    disabled(schemaPath.name);
    disabled(schemaPath.url);
  });

  rakutenAdvertiser = signal<{
    advertiser: {
      can_partner: boolean;
      contact: {
        name: string;
        job_title: string;
        email: string;
        phone: string;
        country: string;
      },
      features: {
        premium_advertiser: boolean;
        product_feed: boolean;
        media_opt_report: boolean;
        cross_device_tracking: string;
        deep_links: boolean;
        itp_compliant: boolean;
      },
      id: number;
      name: string;
      network: number;
      policies: {
        international_capabilities: {
          ships_to: string[];
          software: {
            dsa: boolean;
            dsa_specs: string;
          }
        };
      };
      url: string;
    };
    _metadata: {
      api_name_version: string;
      _links: any;
    }
  } | undefined>(undefined);

  partnershipError = signal<boolean>(false);
  foundPartnership = signal<{
    _metadata: {
      api_name_version: string;
      _links: {
        self: string;
      };
    };
    partnership: {
      advertiser: {
        id: number;
        network: number;
        name: string;
        status: string;
        categories: string[];
        details: string;
      };
      status: string;
      status_update_datetime: string;
      approve_datetime: string;
      apply_datetime: string;
      offers: string;
    };
  } | undefined>(undefined);


  rakutenModeDetails: string[] = [
    'Unlimited affiliate briefs',
    'Affiliate earning for creators',
    'Creators pay for themselves',
    'Tracking & reporting',
    'Built for Rakuten',
    'Rakuten partnership',
    'Any existing Rakuten deals',
    'Use the existing Rakuten products'
  ]

  shopifyModeDetails: string[] = [
    'Unlimited affiliate briefs',
    'Affiliate earning for creators',
    'Creators pay for themselves',
    'Tracking & reporting',
    'Built for Shopify',
    'Shopify partnership',
    'Use the existing Shopify products',
    'Plugs into your Shopify store directly',
  ]

  /** Services */
  private currentUserService = inject(CurrentUserService);
  private businessAccountService = inject(BusinessAccountService);
  /** Services - END */

  ngOnInit(): void {
    this.rakutenAdvertiserIdModel.set({
      rakutenAdvertiserId: this.currentUserService.focussedBrand.rakutenAdvertiserId ?? '',
    });

    if (this.currentUserService.focussedBrand.rakutenAdvertiserId) {
      this.getAdvertiser();
      this.getPartnership();
    }
  }

  getAdvertiser() {
    this.businessAccountService.findRakutenAdvertiserByBusinessAccountId(this.currentUserService.focussedBrand.id).pipe(take(1)).subscribe((advertiser: any) => {
      console.log('Advertiser found:', advertiser);
      this.rakutenAdvertiser.set(advertiser);
      this.foundAdvertiserModel.set({
        name: advertiser.advertiser.name,
        url: advertiser.advertiser.url.replace('https://', '').replace('http://', ''),
      });
    });
  }

  getPartnership() {

    this.businessAccountService.findRakutenPartnershipByBusinessAccountId(this.currentUserService.focussedBrand.id).pipe(take(1)).subscribe((partnership: any) => {
      console.log('Partnership found:', partnership);
      if (partnership && partnership.message && partnership.message.includes('404')) {
        this.partnershipError.set(true);
      } else {
        this.foundPartnership.set(partnership);
      }
      this.foundPartnership.set(partnership)
    }, error => {
      console.error('Error finding partnership:', error);
      this.partnershipError.set(true);
    });


  }


  saveRakutenChanges() {
    console.log('saveRakutenChanges()');

    let rakutenAdvertiserIdTouched = this.rakutenAdvertiserIdForm.rakutenAdvertiserId().touched();

    if (rakutenAdvertiserIdTouched) {
      console.log('Saving Rakuten Advertiser ID');
      this.updatingAffiliateChanges.set(true);
      this.businessAccountService.updateBusinessAccountPartial(this.currentUserService.focussedBrand.id, {
        rakutenAdvertiserId: this.rakutenAdvertiserIdModel().rakutenAdvertiserId,
      }).pipe(take(1)).subscribe((businessAccount: any) => {
        console.log('Business account updated:', businessAccount);
        this.currentUserService.setFocussedBrand(businessAccount);
        this.updatingAffiliateChanges.set(false);
        this.getAdvertiser();
        setTimeout(() => {
          this.updatingAffiliateChanges.set(false);
        }, 500);
      });
    }

  }
}
